import { apiClient } from './api';

export type AddressType = 'shipping' | 'billing';

export interface CustomerAddress {
  id: number;
  user_id: number;
  address_type: AddressType;
  address_line1: string;
  address_line2: string | null;
  city: string;
  state: string;
  zip_code: string;
  is_default: boolean;
  created_at: string;
  updated_at: string;
}

export interface AddressInput {
  address_type: AddressType;
  address_line1: string;
  address_line2?: string;
  city: string;
  state: string;
  zip_code: string;
  is_default?: boolean;
}

export async function listMyAddresses(): Promise<CustomerAddress[]> {
  const raw = await apiClient.get<{ data: CustomerAddress[] }>('/customers/me/addresses');
  return raw.data ?? (raw as any);
}

export async function createMyAddress(input: AddressInput): Promise<CustomerAddress> {
  return apiClient.post<CustomerAddress>('/customers/me/addresses', input);
}

export async function updateMyAddress(
  id: number,
  input: Partial<AddressInput>
): Promise<CustomerAddress> {
  return apiClient.patch<CustomerAddress>(`/customers/me/addresses/${id}`, input);
}

export async function deleteMyAddress(id: number): Promise<void> {
  await apiClient.delete<void>(`/customers/me/addresses/${id}`);
}
